import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import React, { useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Hotjar from '@hotjar/browser';

import './App.css';
import AppRoutes from './Routes';
import { AuthProvider } from './Auth';

const theme = createTheme({
	palette: {
		primary: {
			main: '#164172',
		},
		secondary: {
			main: '#231F20',
		},
		alternateSecondary: {
			main: '#CCCCCC',
		},
	},
});

function App() {
	useEffect(() => {
		const siteId = 6490676;
		const hotjarVersion = 6;
		Hotjar.init(siteId, hotjarVersion);
	}, []);

	return (
		<AuthProvider>
			<ThemeProvider theme={theme}>
				<AppRoutes />
			</ThemeProvider>
		</AuthProvider>
	);
}

export default App;
